import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function AlertConfirm(props) {
  const {
    show,
    alertHeader,
    alertMessage,
    handleClose,
    handleConfirm,
    confirmText = "Yes",
    cancelText = "No",
  } = props;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{alertHeader}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mt-3">{alertMessage}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {cancelText}
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AlertConfirm;
